/* =========================
   VIDEO POPUP
========================= */

document.addEventListener('click', function (e) {

   /* -------- Open Popup -------- */

   const card = e.target.closest('.membership-video-card');

   if (card) {

      const popup = document.getElementById('membershipVideoPopup');

      if (!popup) return;

      const popupVideo = popup.querySelector('video');

      const videoUrl = card.dataset.videoUrl;

      if (!videoUrl) return;

      popupVideo.src = videoUrl;

      popup.classList.add('active');

      popupVideo.play();

      document.body.style.overflow = 'hidden';
   }

   /* -------- Close Popup -------- */

   if (
      e.target.closest('.membership-popup-close') ||
      e.target.classList.contains('membership-video-popup-overlay')
   ) {

      const popup = document.getElementById('membershipVideoPopup');

      if (!popup) return;

      const popupVideo = popup.querySelector('video');

      popupVideo.pause();

      popupVideo.src = '';

      popup.classList.remove('active');

      document.body.style.overflow = '';
   }

});


/* =========================
   Wishlist Setup
========================= */

if (window.customerId) {

   console.log('customer_id', window.customerId);

   const STORAGE_KEY = `wishlist_${window.customerId}`;

   function getWishlist() {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
   }

   function saveWishlist(data) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
   }

   function updateWishlistCount() {
      const wishlist = getWishlist();

      document.querySelectorAll('.wishlist_count').forEach(el => {
         el.innerText = wishlist.length;
      });
   }


   /* =========================
      On Page Load
   ========================= */

   document.addEventListener('DOMContentLoaded', () => {

      const wishlist = getWishlist();

      document.querySelectorAll('.membership-video-card_wrap').forEach(card => {

         const id = card.dataset.id;

         const wishIcon = card.querySelector('.whishlist_icon');

         const exists = wishlist.find(item => item.id === id);

         if (wishIcon) {
            wishIcon.classList.toggle('filled_heart', !!exists);
         }

      });

      updateWishlistCount();

   });


   /* =========================
      Click Events
   ========================= */

   document.addEventListener('click', e => {

      /* -------- Modal (more) -------- */

      if (e.target.closest('.xmore_contentx')) {

         const w = e.target.closest('.xvideo_content_wrapx');

         const content = w.querySelector('.full_text').innerHTML;

         document.querySelector('.custom_modal')?.remove();

         const modal = document.createElement('div');

         modal.className = 'custom_modal active';

         modal.innerHTML = `
         <div class="modal_overlay"></div>

         <div class="modal_box">
            <span class="close_modal">×</span>

            <div class="modal_content">
               ${content}
            </div>
         </div>
         `;

         document.body.appendChild(modal);

         document.body.classList.add('modal_open');
      }


      /* -------- Close Modal -------- */

      if (
         e.target.classList.contains('modal_overlay') ||
         e.target.classList.contains('close_modal')
      ) {

         document.querySelector('.custom_modal')?.remove();

         document.body.classList.remove('modal_open');
      }


      /* =========================
         Wishlist Toggle
      ========================= */

      const wish = e.target.closest('.whishlist_icon');

      if (!wish) return;

      const card = wish.closest('.membership-video-card_wrap');

      const id = card.dataset.id;

      const data = {
         id: id,
         poster: card.querySelector('video')?.getAttribute('poster'),
         videoUrl: card.querySelector('.membership-video-card')?.dataset.videoUrl,
         videoType: card.querySelector('.membership-video-card')?.dataset.type,
         heading: card.querySelector('h3')?.innerText,

         content: {
            short: card.querySelector('.xshort_textx')?.innerText.replace('more', '').trim(),
            full: card.querySelector('.full_text')?.innerText.trim()
         },

         productUrl: card.querySelector('.video_content_btn')?.getAttribute('href'),

         productLabel: card.querySelector('.video_content_btn')?.innerText.trim()
      };

      let wishlist = getWishlist();

      const exists = wishlist.find(item => item.id === id);

      if (exists) {

         wishlist = wishlist.filter(item => item.id !== id);

         wish.classList.remove('filled_heart');

      } else {

         wishlist.push(data);

         wish.classList.add('filled_heart');
      }

      saveWishlist(wishlist);

      updateWishlistCount();

   });


   /* =========================
      Watchlist Page
   ========================= */

   if (window.watchTemplate === "watchlist" && window.customerId) {

      const wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

      const grid = document.querySelector('.membership-video-grid');


      if (!wishlist.length) {

         if (grid) {
            grid.innerHTML = '<p class="empty-watchlist">No items in wishlist</p>';
         }
      }


      if (grid) {

         grid.classList.remove('for_desktop');

         grid.classList.add('watchlist_grid');

         grid.innerHTML = '';

         wishlist.forEach(item => {

            const card = document.createElement('div');

            card.className = 'membership-video-card_wrap card-wrap-default';

            card.dataset.id = item.id;

            card.innerHTML = `
            <div class="membership-video-card" data-video-url="${item.videoUrl}" data-type="${item.videoType}">

               <video poster="${item.poster}">
                  <source src="${item.videoUrl}" type="${item.videoType}">
               </video>

               <div class="membership-video-overlay">
                  <div class="membership-play-icon">
                     <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 320 320">
                        <path fill="#fff" d="M295.8 146L40 2A16 16 0 0024 16v288a16 16 0 0016 14l256-144a16 16 0 000-28z"></path>
                     </svg>
                  </div>
               </div>

            </div>

            <span class="whishlist_icon watchlist_cross">

               <svg width="25" height="25" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">

                  <circle cx="20" cy="20" r="18" fill="none" stroke="#ffffff" stroke-width="2"/>

                  <line x1="14" y1="14" x2="26" y2="26" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"/>

                  <line x1="26" y1="14" x2="14" y2="26" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"/>

               </svg>

            </span>

            <div class="membership-video-content">

               <h3>${item.heading}</h3>

               <div class="xvideo_content_wrapx">

                  <p class="xshort_textx">
                     ${item.content.short}
                     <span class="xmore_contentx">more</span>
                  </p>

                  <div class="full_text" style="display:none;">
                     ${item.content.full}
                  </div>

               </div>

               <a href="${item.productUrl}" class="video_content_btn ctm_btn_wrap">
                  ${item.productLabel}
               </a>

            </div>
            `;

            grid.appendChild(card);

         });


         document.addEventListener('click', e => {

            const removeBtn = e.target.closest('.watchlist_cross');

            if (removeBtn) {

               const card = removeBtn.closest('.membership-video-card_wrap');

               const id = card.dataset.id;

               let wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

               wishlist = wishlist.filter(item => item.id !== id);

               localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

               card.remove();

               document.querySelectorAll('.wishlist_count').forEach(el => {
                  el.innerText = wishlist.length;
               });

               if (!wishlist.length) {

                  if (grid) {
                     grid.innerHTML = '<p class="empty-watchlist">No items in wishlist</p>';
                  }

               }

            }

         });

      }

   }

}